<template>
  <div id="app">
    <div class="wechat-top-banner">V✨：wysly565</div>
    <div v-if="shouldShowVersionBar" class="version-bar">
      <div
        class="version-tag"
        :class="{ 'version-tag-update': needUpdate }"
        @click="handleVersionClick"
      >
        <span v-if="!needUpdate">版本号：{{ localVersionName }}</span>
        <span v-else>点击更新</span>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import API_CONFIG from '@/api/config'

export default {
  name: 'App',
  data() {
    return {
      hasAuthToken: false,
      localVersionCode: 0,
      localVersionName: '',
      serverVersionCode: 0,
      downloadUrl: ''
    }
  },
  computed: {
    needUpdate() {
      if (!this.serverVersionCode) {
        return false
      }
      return Number(this.localVersionCode) !== Number(this.serverVersionCode)
    },
    shouldShowVersionBar() {
      return this.hasAuthToken && this.$route.path !== '/'
    }
  },
  mounted() {
    this.refreshVersionState()
  },
  watch: {
    $route() {
      this.refreshVersionState()
    }
  },
  methods: {
    refreshVersionState() {
      this.hasAuthToken = !!localStorage.getItem('authToken')
      this.localVersionCode = API_CONFIG.getAppVersionCode()
      this.localVersionName = API_CONFIG.getAppVersionName()
      this.serverVersionCode = Number(localStorage.getItem('serverVersionCode') || 0)
      this.downloadUrl = localStorage.getItem('downloadUrl') || ''
    },
    handleVersionClick() {
      if (!this.needUpdate) {
        return
      }
      if (!this.downloadUrl) {
        alert('未获取到下载链接')
        return
      }
      window.open(this.downloadUrl, '_blank')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #f5f5f5;
}

#app {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
}

.wechat-top-banner {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  color: #0066cc;
  font-size: 14px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(0, 102, 204, 0.25);
  border-radius: 999px;
  padding: 4px 12px;
  line-height: 1.2;
  user-select: text;
}

.version-bar {
  position: fixed;
  top: 10px;
  right: 12px;
  z-index: 3000;
  display: flex;
  align-items: center;
  gap: 8px;
}

.version-tag {
  background: rgba(19, 34, 61, 0.86);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1;
  cursor: default;
  user-select: none;
}

.version-tag-update {
  background: rgba(216, 52, 52, 0.92);
  border-color: rgba(255, 99, 99, 0.85);
  color: #fff;
  cursor: pointer;
  font-weight: 600;
}

.customer-wechat-image {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: #fff;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.6);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.8);
}

/* 全局动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 全局按钮样式 */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* 全局卡片样式 */
.card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 25px;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

/* 全局输入框样式 */
.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  
  .btn {
    padding: 10px 20px;
    font-size: 13px;
  }
  
  .card {
    padding: 20px;
  }
}
</style>
